"use strict";

module.exports = function () {
  if (this.orderBy.column != this.groupBy[0]) {
    this.setOrder(this.groupBy[0], true);
  } else {
    this.setOrder(this.groupBy[0], !this.orderBy.ascending);
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2-premium/compiled/methods/toggle-group-direction.js
// module id = 951
// module chunks = 0